import type { UserLocale } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { X } from "lucide-react";

interface UserLocaleFilterProps {
  value: UserLocale;
  onChange: (value: UserLocale) => void;
}

export function UserLocaleFilter({ value, onChange }: UserLocaleFilterProps) {
  const addLocale = () => onChange({ ...value, locales: [...value.locales, ""] });
  const updateLocale = (i: number, v: string) => {
    const next = [...value.locales];
    next[i] = v;
    onChange({ ...value, locales: next });
  };
  const removeLocale = (i: number) =>
    onChange({ ...value, locales: value.locales.filter((_, j) => j !== i) });

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-xs">Locales</Label>
        <Button type="button" variant="outline" size="sm" onClick={addLocale}>
          Add Locale
        </Button>
      </div>
      {value.locales.map((loc, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input
            value={loc}
            onChange={(e) => updateLocale(i, e.target.value)}
            placeholder="en-US"
            className="flex-1"
          />
          <Button type="button" variant="ghost" size="icon" onClick={() => removeLocale(i)}>
            <X className="h-4 w-4 text-red" />
          </Button>
        </div>
      ))}
    </div>
  );
}
